if (!customElements.get('product-modal')) {
  customElements.define(
    'product-modal',
    class ProductModal extends ModalDialog {
      constructor() {
        super();
        this.prevButton = this.querySelector('.product-media-modal__prev');
        this.nextButton = this.querySelector('.product-media-modal__next');
        if (this.prevButton) this.prevButton.addEventListener('click', this.onButtonClick.bind(this, -1));
        if (this.nextButton) this.nextButton.addEventListener('click', this.onButtonClick.bind(this, 1));
      }

      onButtonClick(direction) {
        const activeItem = this.querySelector('.active');
        const items = Array.from(this.querySelectorAll('.product-media-modal__content > *'));
        let index = items.indexOf(activeItem);
        index = (index + direction + items.length) % items.length;
        this.setActiveMedia(items[index]);
      }

      hide() {
        super.hide();
      }

      show(opener) {
        super.show(opener);
        this.showActiveMedia();
      }

      showActiveMedia() {
        const activeMedia = this.querySelector(`[data-media-id="${this.openedBy.getAttribute('data-media-id')}"]`);
        this.setActiveMedia(activeMedia);
      }

      setActiveMedia(activeMedia) {
        this.querySelectorAll('.product-media-modal__content > *').forEach((element) => {
          element.classList.remove('active');
        });
        activeMedia.classList.add('active');
        activeMedia.scrollIntoView({ behavior: 'smooth', block: 'nearest', inline: 'center' });

        const activeMediaTemplate = activeMedia.querySelector('template');
        const activeMediaContent = activeMediaTemplate ? activeMediaTemplate.content : null;

        if (
          activeMedia.nodeName == 'DEFERRED-MEDIA' &&
          activeMediaContent &&
          activeMediaContent.querySelector('.js-youtube')
        )
          activeMedia.loadContent();
      }
    }
  );
}
